
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tips-sample-pages",
      function () {
        return require("private-next-pages/tips-sample-pages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tips-sample-pages"])
      });
    }
  